/**
 * connected-react-router removed. It's a v5-router-only library —
 * `ConnectedRouter` reads/writes the external `history` object's internal
 * shape directly, which fundamentally changed under react-router-dom v6
 * (v6 manages its own history internally and doesn't accept an injected
 * `history` prop the way v5 did). Mounting v6's <Routes> inside a v5-style
 * <ConnectedRouter> crashed immediately on mount
 * ("Cannot read properties of undefined (reading 'pathname')").
 *
 * Per confirmation that nothing in the app reads `state.router` (the only
 * reason connected-react-router's reducer/middleware existed here), this
 * is a clean removal:
 *   - `routerMiddleware(history)` dropped from the middleware list.
 *   - `reducerWithRouter(history)` (which only ever did
 *     `combineReducers({ ...reducerMap, router: connectRouter(history) })`)
 *     replaced with the plain `combineReducers(reducerMap)` already
 *     exported as the default from ./reducer — every real app reducer was
 *     already listed there independent of routing, so nothing else changes.
 *   - `history` parameter removed entirely; the caller (src/index.js) no
 *     longer creates or passes one. Routing now goes through a plain
 *     <BrowserRouter> in index.js, which manages its own history
 *     internally — see that file's fix.
 */
import { applyMiddleware, compose, createStore as _createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import reducer from './reducer';
import saga from './saga';

export function createStoreWeb(initialState = {}) {
  let composeEnhancers = compose;
  let reduxSagaMonitorOptions = {};

  if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});

    if (window.__SAGA_MONITOR_EXTENSION__)
      reduxSagaMonitorOptions = {
        sagaMonitor: window.__SAGA_MONITOR_EXTENSION__,
      };
  }

  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

  // Create the store with one middleware: sagaMiddleware (makes redux-sagas work).
  const middlewares = [sagaMiddleware];

  const enhancers = [applyMiddleware(...middlewares)];

  const store = _createStore(
    reducer,
    initialState,
    composeEnhancers(...enhancers),
  );

  sagaMiddleware.run(saga);

  return store;
}